import React from 'react';
import { Reveal, AnimatedDivider } from './effects';

const CHAIRMAN_IMG =
  '/site/murat-gun-profil.webp';

const PARAGRAPHS = [
  'Tarhun Catering olarak çıktığımız bu yolculukta; kaliteyi, güveni ve sürdürülebilir hizmet anlayışını temel ilkemiz olarak benimsedik. Kurulduğumuz ilk günden bu yana müşterilerimize yalnızca yemek hizmeti sunmayı değil, aynı zamanda sağlıklı, hijyenik ve yüksek standartlarda bir yaşam deneyimi yaşatmayı hedefledik.',
  'Bugün geldiğimiz noktada; güçlü operasyon altyapımız, deneyimli ekibimiz ve yenilikçi bakış açımız sayesinde sektörümüzde güvenilir markalardan biri olmanın gururunu taşıyoruz. Her projeye aynı titizlikle yaklaşarak insan sağlığını, müşteri memnuniyetini ve kurumsal sorumluluğu ön planda tutuyoruz.',
  'Tarhun Catering\'in başarısının arkasında; işine tutkuyla bağlı çalışanlarımız, bize güvenen iş ortaklarımız ve kalite anlayışımızdan ödün vermeyen hizmet yaklaşımımız bulunmaktadır. Gelişen dünyayı yakından takip ederek teknolojiyi ve modern üretim sistemlerini süreçlerimize entegre etmeye devam ediyoruz.',
  'Önümüzdeki dönemde de büyüyen hizmet ağımız, yenilikçi çözümlerimiz ve güçlü vizyonumuzla sektörümüze değer katmayı sürdüreceğiz. Bizlere duyduğunuz güven için teşekkür ediyor; Tarhun Catering ailesi olarak sizlere en iyi hizmeti sunmaya devam edeceğimizi belirtmek istiyorum.',
];

const ChairmanMessage = () => {
  return (
    <section
      className="relative bg-[#F5F3EF] pt-[150px] lg:pt-[180px] pb-24 lg:pb-32 overflow-hidden"
      aria-label="Başkanın Mesajı"
      data-testid="chairman-message-section"
    >
      {/* Subtle dot texture */}
      <div
        className="absolute inset-0 opacity-[0.04] pointer-events-none"
        style={{
          backgroundImage: 'radial-gradient(circle at 1px 1px, #1A1A1A 1px, transparent 0)',
          backgroundSize: '34px 34px',
        }}
      />

      <div className="container-x relative">
        {/* SECTION HEADER */}
        <div className="flex items-center gap-3 mb-12 lg:mb-16">
          <AnimatedDivider width="3rem" />
          <Reveal delay={80} y={8} duration={700}>
            <span className="text-[10.5px] tracking-[0.34em] uppercase text-[#9A7F4F] font-medium">
              Başkanın Mesajı · Tarhun Catering
            </span>
          </Reveal>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-start">
          {/* LEFT — Portrait + identity card */}
          <div className="lg:col-span-5 lg:sticky lg:top-32">
            <Reveal y={28} duration={900}>
              <div className="relative">
                {/* Gold frame accent */}
                <div className="absolute -inset-3 lg:-inset-5 border border-[#C9A875]/30 rounded-sm pointer-events-none" />
                <div
                  className="relative aspect-[4/5] overflow-hidden rounded-sm bg-[#1A1A1A] shadow-[0_40px_90px_-30px_rgba(0,0,0,0.45)]"
                  data-testid="chairman-portrait"
                >
                  <img
                    src={CHAIRMAN_IMG}
                    alt="Murat Gün — Tarhun Catering Yönetim Kurulu Başkanı"
                    className="w-full h-full object-cover"
                    loading="eager"
                  />
                  {/* Bottom soft gradient for editorial feel */}
                  <div
                    className="absolute inset-x-0 bottom-0 h-1/3 pointer-events-none"
                    style={{
                      background:
                        'linear-gradient(180deg, rgba(10,12,11,0) 0%, rgba(10,12,11,0.55) 100%)',
                    }}
                  />
                </div>
              </div>
            </Reveal>
          </div>

          {/* RIGHT — Headline + message body */}
          <div className="lg:col-span-7">
            <Reveal y={24} duration={900}>
              <h1
                className="font-display text-[44px] sm:text-[56px] lg:text-[78px] text-[#1A1A1A] leading-[1.02] tracking-[-0.025em]"
                style={{ fontWeight: 500 }}
                data-testid="chairman-headline"
              >
                Bir kurumun{' '}
                <span className="italic font-light text-[#72272D]">değeri</span>,
                <br className="hidden sm:block" /> sözünün arkasında durmasıyla ölçülür.
              </h1>
            </Reveal>

            <Reveal delay={250} y={20}>
              <div className="mt-10 lg:mt-12 max-w-[640px] space-y-6">
                {PARAGRAPHS.map((p, idx) => (
                  <p
                    key={idx}
                    className="text-[15.5px] lg:text-[16.5px] text-[#1A1A1A]/78 leading-[1.78]"
                    style={{ textWrap: 'pretty' }}
                  >
                    {p}
                  </p>
                ))}
              </div>
            </Reveal>

            {/* Signature block */}
            <Reveal delay={450} y={16}>
              <div className="mt-12 lg:mt-14 max-w-[640px] pt-8 border-t border-[#1A1A1A]/10">
                <p className="text-[13.5px] tracking-[0.04em] text-[#1A1A1A]/55 italic">
                  Saygılarımla,
                </p>
                <p
                  className="mt-3 font-display text-[28px] lg:text-[34px] text-[#1A1A1A] leading-[1.05] tracking-[-0.01em]"
                  style={{ fontWeight: 500, fontStyle: 'italic' }}
                >
                  Murat Gün
                </p>
                <p className="mt-2 text-[11.5px] tracking-[0.28em] uppercase text-[#9A7F4F] font-medium">
                  Yönetim Kurulu Başkanı · Tarhun Catering
                </p>
              </div>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ChairmanMessage;
